// import React from 'react';
import useWindowSize from '../hooks/useWindowSize';

const MobileOptimizedForm = ({
  children,
  onSubmit,
  className = '',
  style = {},
  title,
  subtitle,
  loading = false,
  error,
  success,
  ...props
}) => {
  const { isMobile } = useWindowSize();

  const formStyle = {
    width: '100%',
    maxWidth: isMobile ? '100%' : '600px',
    margin: '0 auto',
    padding: isMobile ? '0' : '20px',
    backgroundColor: '#ffffff',
    borderRadius: isMobile ? '0' : '12px',
    boxShadow: isMobile ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)',
    ...style,
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: isMobile ? '24px' : '30px',
    padding: isMobile ? '20px 0' : '0',
  };

  const titleStyle = {
    fontSize: isMobile ? '1.8rem' : '2rem',
    fontWeight: '700',
    color: '#061156',
    marginBottom: '8px',
    lineHeight: '1.2',
  };

  const subtitleStyle = {
    fontSize: isMobile ? '16px' : '18px',
    color: '#6c757d',
    margin: '0',
    lineHeight: '1.5',
  };

  const alertStyle = {
    padding: isMobile ? '16px' : '12px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: isMobile ? '15px' : '14px',
    lineHeight: '1.4',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  const errorAlertStyle = {
    ...alertStyle,
    backgroundColor: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb',
  };

  const successAlertStyle = {
    ...alertStyle,
    backgroundColor: '#d4edda',
    color: '#155724',
    border: '1px solid #c3e6cb',
  };

  const loadingOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'inherit',
    zIndex: 10,
  };

  const spinnerStyle = {
    width: '32px',
    height: '32px',
    border: '3px solid #f3f3f3',
    borderTop: '3px solid #4352A9',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (onSubmit) {
      onSubmit(e);
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <form
        onSubmit={handleSubmit}
        style={formStyle}
        className={className}
        noValidate
        {...props}
      >
        {(title || subtitle) && (
          <div style={headerStyle}>
            {title && <h1 style={titleStyle}>{title}</h1>}
            {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
          </div>
        )}

        {error && (
          <div style={errorAlertStyle} role="alert">
            <span className="material-icons" style={{ fontSize: '20px' }}>
              error
            </span>
            {error}
          </div>
        )}

        {success && (
          <div style={successAlertStyle} role="alert">
            <span className="material-icons" style={{ fontSize: '20px' }}>
              check_circle
            </span>
            {success}
          </div>
        )}

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isMobile ? '20px' : '16px',
        }}>
          {children}
        </div>

        {loading && (
          <div style={loadingOverlayStyle}>
            <div style={spinnerStyle}></div>
          </div>
        )}
      </form>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MobileOptimizedForm;
